export const INITIAL_CREATE_MISSION_DATA = {
  company: null,
  idLocation: null,
  activity: '',
  qualification: '',
  title: '',
  tools: [],
  licences: [],
  languages: [],
  contact_name: '',
  contact_poste: 'Responsable',
  location: '',
  dateStart: '',
  dateEnd: '',
  schedule: [],
  isScheduleCheck: true,
  isConfirmedSchedule: false,
  isScheduleRequired: false,
  users_invite: [],
  motif: '',
  other: '',
  other_interim: '',
  salary: '',
  inviteType: '',
  vivierStatus: [],
  vivierSelections: [],
  globalNotificationRequested: false,
  user_assigned: {},
  reference: '',
};

const isEmptyComparableValue = (value) => {
  if (value == null || value === '') return true;
  if (Array.isArray(value)) return value.length === 0;
  if (typeof value === 'object') return Object.keys(value).length === 0;
  return false;
};

const normalizeComparableValue = (value) => {
  if (isEmptyComparableValue(value)) return null;

  if (Array.isArray(value)) {
    const normalizedItems = value
      .map(normalizeComparableValue)
      .filter((item) => item != null);
    return normalizedItems.length ? normalizedItems : null;
  }

  if (typeof value === 'object') {
    const normalizedEntries = Object.entries(value)
      .map(([key, nestedValue]) => [key, normalizeComparableValue(nestedValue)])
      .filter(([, nestedValue]) => nestedValue != null)
      .sort(([keyA], [keyB]) => keyA.localeCompare(keyB));

    if (!normalizedEntries.length) return null;
    return Object.fromEntries(normalizedEntries);
  }

  return value;
};

const areComparableValuesEqual = (left, right) =>
  JSON.stringify(normalizeComparableValue(left)) ===
  JSON.stringify(normalizeComparableValue(right));

export const hasChangesSinceBaseline = (current, baseline) =>
  !areComparableValuesEqual(current, baseline);
